import React from "react";
import {BLOCK_TYPE} from "draftail";

import PopupMenuButton from "src/core/gd-components/popover-menu/popup-menu-button/popup-menu-button";
import SizePopoverOptions from "./size-popover-options";

export default function ToolbarSizeControls(props) {

    const arrOptions = [
        { label: 'Normal',      value: BLOCK_TYPE.UNSTYLED },
        { label: 'Header 1',    value: BLOCK_TYPE.HEADER_ONE },
        { label: 'Header 2',    value: BLOCK_TYPE.HEADER_TWO },
        { label: 'Header 3',    value: BLOCK_TYPE.HEADER_THREE }
    ];

    const valueSelected = [BLOCK_TYPE.UNSTYLED, BLOCK_TYPE.HEADER_ONE, BLOCK_TYPE.HEADER_TWO, BLOCK_TYPE.HEADER_THREE].includes(props.currentBlock);
    const value = valueSelected ? props.currentBlock : BLOCK_TYPE.UNSTYLED;

    const button = () => {
        // const labelClasses = Classes("size-styles-label", "ui5-txt-not-important-small", "m-r-5", {
        //     selected: value !== BLOCK_TYPE.UNSTYLED
        // });
        // <div className="ui5-arrow-toggle s8 open"/>

        return (
            <React.Fragment>
                <div className="btn-label">{value ? _.find(arrOptions, o=>o.value === value).label : 'Select style'}</div>
                <div className="ui5-triangle-toggle s6 open m-l-5 m-t-3"/>
            </React.Fragment>
        )
    }

    //timeout is required for type to change (otherwise nothing is selected in editor while new type is processed)
    const onChangeStyle = (value)=>{setTimeout(()=>{props.toggleBlockType(value)}, 0)};

    const classes = Classes("ui5-control-button-with-label s-26",{
        selected: value !== BLOCK_TYPE.UNSTYLED
    })

    return (
        <div className="gd-draftail-toolbar-group">
            <PopupMenuButton className={classes}
                             hint="Select style"
                             btnComponent={button}
                             menuComponent={SizePopoverOptions}
                             menuParams={{
                                 value,
                                 onChangeStyle
                             }}/>
        </div>
    );
}
